import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled, css, useTheme } from 'styled-components';
import BarsLoader from '../../Elements/BarsLoader/index.js';
const ExternalLink = styled.a `
  display: flex;
  align-items: center;
  padding: 5px 15px;
  width: 100%;
  min-height: 36px;
  color: ${({ theme }) => theme.colors.black_1}!important;
  text-decoration: none;
`;
const Wrapper = styled.li `
  padding: ${({ $externalLink }) => ($externalLink ? 0 : '5px 15px')};
  font-size: 13px;
  display: flex;
  justify-content: space-between;
  min-height: 36px;
  align-items: center;
  transition: 0.15s;
  white-space: ${({ $wrap }) => ($wrap ? 'normal' : 'nowrap')};
  color: ${({ theme }) => theme.colors.black_1};
  position: ${({ $isCustomChildren }) => $isCustomChildren && 'relative'};
  > *:not(:first-child) {
    margin-left: 10px;
  }
  ${({ $disabled }) => $disabled &&
    css `
      opacity: 0.3;
      cursor: not-allowed;
    `}
  ${({ $disabled }) => !$disabled &&
    css `
      cursor: pointer;
      &:hover {
        background-color: ${({ theme }) => theme.colors.grey05_1};
      }
    `}
`;
const Item = ({ children, isLoading = false, wrap, disabled = false, onClick = undefined, id, externalLink = '', isCustomChildren, ...other }) => {
    const theme = useTheme();
    return (_jsxs(Wrapper, { $wrap: wrap, $disabled: disabled || isLoading, onClick: (e) => !isLoading && !disabled && onClick && onClick(e), id: id, $externalLink: externalLink, $isCustomChildren: isCustomChildren, ...other, children: [externalLink ? (_jsx(ExternalLink, { href: externalLink, target: '_blank', rel: 'noopener noreferrer', children: children })) : (_jsx(_Fragment, { children: isCustomChildren ? children : _jsx("span", { children: children }) })), isLoading && _jsx(BarsLoader, { bgColor: theme.colors.black_1 })] }));
};
export default Item;
